import { Column, GridApi } from 'ag-grid-community';
import { Badge, Collapse } from 'antd';
import { observer } from 'mobx-react-lite';

import {
  TEntityGridExtraFilter,
  TEntityGridFilter,
} from 'app/common/entity-grid/core';
import { useInstance } from 'app/libs/use-instance';

import { BaseFilterModel } from '../filters/create-data-grid-filter';
import { FilterComponent } from './filter-component';
import { useFilterModel } from './use-filter-model';

const { Panel } = Collapse;

const PanelHeader = observer(
  ({ column, gridApi }: { column: Column; gridApi: GridApi }) => {
    const [model] = useFilterModel({ column, gridApi });
    const headerName = useInstance(
      () => column.getUserProvidedColDef()?.headerName || column.getColId(),
    );

    return (
      <span>
        {model && <Badge status="processing" style={{ marginRight: 8 }} />}
        {headerName}
      </span>
    );
  },
);

// type ExtraFilters<Comp extends DataGridFilterComponents> = ((
//   props: Omit<Parameters<Comp>[0], 'column'>,
// ) => ReturnType<Comp>) &
//   FilterModels;

type FiltersCollapseProps = {
  columns: Column[];
  extraFilters?: TEntityGridExtraFilter[];
  gridApi: GridApi | null;
  filterModels?: TEntityGridFilter | null;
  onExtraFilterChange?: (model: BaseFilterModel<unknown, string>) => void;
};

export const FiltersCollapse = observer(
  ({
    columns,
    extraFilters,
    gridApi,
    filterModels,
    onExtraFilterChange,
  }: FiltersCollapseProps) => {
    if (!gridApi) return null;

    const existedExtraFilters = Array.isArray(extraFilters) ? extraFilters : [];

    return (
      <Collapse>
        {columns.map((column) => {
          if (!gridApi) return null;

          const colId = column.getColId();

          return (
            <Panel
              key={colId}
              header={<PanelHeader column={column} gridApi={gridApi} />}
            >
              <FilterComponent column={column} gridApi={gridApi} />
            </Panel>
          );
        })}

        {existedExtraFilters.map((filterObject) => {
          const FilterComponent = filterObject.component;
          const header = filterObject.header;
          const filterName = FilterComponent.filterName;
          const value = filterModels?.[filterName] || null;

          const handleModelChange = (
            model: BaseFilterModel<unknown, string> | null,
          ) => {
            model
              ? onExtraFilterChange?.(model)
              : onExtraFilterChange?.(
                  // @ts-expect-error...
                  { filterName, value: null },
                );
          };

          return (
            <Panel
              key="buba"
              header={
                <span>
                  {!!value && (
                    <Badge status="processing" style={{ marginRight: 8 }} />
                  )}
                  {header}
                </span>
              }
            >
              <FilterComponent
                // @ts-expect-error ...
                model={{ filterName, value: value }}
                onModelChange={handleModelChange}
              />
            </Panel>
          );
        })}
      </Collapse>
    );
  },
);
